import { Component } from '@angular/core';

@Component({
  selector: 'xchange-site-footer',
  templateUrl: './site-footer.component.html',
  styleUrl: './site-footer.component.scss'
})
export class SiteFooterComponent {
  currentYear: number = new Date().getFullYear();
}
